/**
 * Helper file for (re)initializing all handlers in a poster gallery page on refresh
 */

import {showBannersAndPopups} from "@/poster-gallery/components/category-page-init.js";

const galleryContentContainer = $('.js-gallery-content-container'),
    gridMasonrySelector = '.js-grid-masonry',
    visibleGridMasonrySelector = `${gridMasonrySelector}:visible`;

/**
 * sets up the common gallery elements for the poster gallery pages
 */
export function initGalleryPage() {
    updateNonPremiumPostersPriceLabel();
    initGalleryHandlers();
    focusSearchFieldForSearchPage();
    // Showing sub-category banner only to anon users and where source is external.
    if (!PMW.isUserLoggedIn() && PMW.isReferrer()) {
        $('.gallery-marketing-banner').removeClass('_hidden');
    }

    //Ahsan(06-04-2023): Disabling design request popup, keeping the code for later
    //Add 'components/show-design-request-popup.js' to 'coreFooterPosterGalleryPage' asset group when enabling it again
    // if (canShowDesignRequestPopup(method)) {
    //     PMW.observeIfDesignRequestPopUpConditionsTrue();
    // }
    const flyParams = PMW.initFlyOutLimits(PMW.util.getControllerFromUrl(window.location.href), PMW.util.getMethodFromUrl(window.location.href));
    window.addEventListener('scroll', PMW.debounce(PMW.doFlyOut.bind(this, flyParams, onShowFlyout, onHideFlyout), 10), {passive: true});
}

export function initGalleryHandlers() {
    initMediaItems();
    initGridMasonry();
    initSubcategoryCarousel();
    showCategoryPageBannersAndPopups();
    PMW.initSearchResultsSuggestions();
    getGridMasonry().masonry('layout');
}

function onShowFlyout() {
    PMW.unifiedGallery.adjustSidebarVerticalMeasurements();
    PMW.posterGallery.adjustSafeSearchNotificationPosition(true);
}

function onHideFlyout() {
    PMW.unifiedGallery.resetSidebarTopValue();
    PMW.posterGallery.adjustSafeSearchNotificationPosition(false);
}

/**
 * Fetches getty image prices for all counties from HTML DOM. Then returns formatted getty price based on user's country
 * code (determined using eligible country code cookie).
 *
 * @returns {string}
 */
function getGettyImageFormattedPrice() {
    const userEligibleCountryCode = PMW.getUserEligibleCountryCode(),
        pricesData = JSON.parse($('.js-getty-image-prices-provider').attr('data-getty-image-prices')),
        gettyImagePriceObj = pricesData[userEligibleCountryCode];

    if (typeof gettyImagePriceObj !== 'undefined' && Object.keys(gettyImagePriceObj).length !== 0) {
        return PMW.util.currencyFormat(gettyImagePriceObj.amount, gettyImagePriceObj.currencyCode);
    }
    return '';
}

/**
 * Updates the price label for all non-premium posters with the correct currency and amount for getty image cost
 */
function updateNonPremiumPostersPriceLabel() {
    let gettyImageFormattedPrice = getGettyImageFormattedPrice();

    if (window.PMW.isPAYGUser() && gettyImageFormattedPrice !== '') {
        let nonPremiumGettyPriceLabel = $('.premium-box.-for-non-premium');
        nonPremiumGettyPriceLabel.attr('data-title', window.i18next.t('pmwjs_getty_image_costs_x_more_non_premium', {price: gettyImageFormattedPrice}));
        nonPremiumGettyPriceLabel.find('.premium').text('+' + gettyImageFormattedPrice).data('title',);
    }
}

// /**
//  * Checks if conditions for showing design request help popup are true or not
//  * @param {string} method
//  * @returns {boolean}
//  */
// function canShowDesignRequestPopup(method) {
//     return (typeof PMW.util !== 'undefined' && PMW.isUserPremium() && (method !== 'restaurant-flyers' && method !== 'menu-templates'));
// }

function initGridMasonry() {
    const controller = PMW.util.getControllerFromUrl(window.location.href),
        method = PMW.util.getMethodFromUrl(window.location.href),
        initFlyOutLimitsCallback = PMW.initFlyOutLimits.bind(this, controller, method);
    let gridOptions = {
        gridSelector: getGridMasonry(),
        lazyLoadingCallback: initFlyOutLimitsCallback,
    };
    gridOptions = addSearchParamsToGridOptions(gridOptions);
    PMW.initializeTemplateGridWithPreviewShortcuts(gridOptions);
}

/**
 * @param {Object} gridOptions
 * @return {Object}
 */
function addSearchParamsToGridOptions(gridOptions) {
    if (!PMW.posterGallery.isSearchPage()) {
        return gridOptions;
    }
    gridOptions.serverParams = {
        searchTerm: PMW.posterGallery.posterGalleryFilters.searchTermFilter.searchTerm,
    };
    return gridOptions;
}

/**
 * @return {jQuery}
 */
function getGridMasonry() {
    return galleryContentContainer.find(visibleGridMasonrySelector);
}

function initSubcategoryCarousel() {
    const subcategoryContainerById = $('#subcategory-container'),
        carouselContainer = $('.carousel-container'),
        subcategoryContainer = (subcategoryContainerById.length > 0) ? subcategoryContainerById : $('#subsizes-carousel-container');

    if (PMW.posterGallery.isGalleryPageWithSubfilterCarousel()) {
        PMW.initSubcategoryCarousel(subcategoryContainer, carouselContainer, true);
    }
}

function showCategoryPageBannersAndPopups() {
    if (PMW.posterGallery.isCategoryPage()) {
        showBannersAndPopups(PMW.util.getMethodFromUrl(window.location.href));
    }
}

function initMediaItems() {
    let autoPlayVideos = $('.auto-play-video');

    if (autoPlayVideos.length) {
        PMW.initVideoItems(null, getGridMasonry());
        PMW.loadVideoItem(autoPlayVideos.first());
    } else {
        PMW.initVideoItems(null);
    }
    PMW.initAndLazyloadGraphics();
}

function focusSearchFieldForSearchPage() {
    if (PMW.posterGallery.isSearchPage()) {
        const searchField = document.querySelector('.js-search-field-input')
        searchField.focus();
        searchField.select();
    }
}